import Vector2 from "../math/Vector2";
import Listener from "../util/Listener";

export enum KeyCode {
    Numpad0 = "Numpad0",
    Numpad1 = "Numpad1",
    Numpad2 = "Numpad2",
    Numpad3 = "Numpad3",
    Numpad4 = "Numpad4",
    Numpad5 = "Numpad5",
    Numpad6 = "Numpad6",
    Numpad7 = "Numpad7",
    Numpad8 = "Numpad8",
    Numpad9 = "Numpad9",
    Digit0 = "Digit0",
    Digit1 = "Digit1",
    Digit2 = "Digit2",
    Digit3 = "Digit3",
    Digit4 = "Digit4",
    Digit5 = "Digit5",
    Digit6 = "Digit6",
    Digit7 = "Digit7",
    Digit8 = "Digit8",
    Digit9 = "Digit9",
    KeyA = "KeyA",
    KeyB = "KeyB",
    KeyC = "KeyC",
    KeyD = "KeyD",
    KeyE = "KeyE",
    KeyF = "KeyF",
    KeyG = "KeyG",
    KeyH = "KeyH",
    KeyI = "KeyI",
    KeyJ = "KeyJ",
    KeyK = "KeyK",
    KeyL = "KeyL",
    KeyM = "KeyM",
    KeyN = "KeyN",
    KeyO = "KeyO",
    KeyP = "KeyP",
    KeyQ = "KeyQ",
    KeyR = "KeyR",
    KeyS = "KeyS",
    KeyT = "KeyT",
    KeyU = "KeyU",
    KeyV = "KeyV",
    KeyW = "KeyW",
    KeyX = "KeyX",
    KeyY = "KeyY",
    KeyZ = "KeyZ",
    Space = "Space",
    Escape = "Escape",
    F1 = "F1",
    F2 = "F2",
    F3 = "F3",
    F4 = "F4",
    F5 = "F5",
    F6 = "F6",
    F7 = "F7",
    F8 = "F8",
    F9 = "F9",
    F10 = "F10",
    F11 = "F11",
    F12 = "F12",
    ScrollLock = "ScrollLock",
    Pause = "Pause",
    Backquote = "Backquote",
    Minus = "Minus",
    Equal = "Equal",
    Backspace = "Backspace",
    Insert = "Insert",
    Home = "Home",
    PageUp = "PageUp",
    Delete = "Delete",
    End = "End",
    PageDown = "PageDown",
    NumLock = "NumLock",
    NumpadDivide = "NumpadDivide",
    NumpadMultiply = "NumpadMultiply",
    NumpadSubtract = "NumpadSubtract",
    NumpadAdd = "NumpadAdd",
    NumpadEnter = "NumpadEnter",
    NumpadDecimal = "NumpadDecimal",
    Tab = "Tab",
    BracketLeft = "BracketLeft",
    BracketRight = "BracketRight",
    Backslash = "Backslash",
    CapsLock = "CapsLock",
    Semicolon = "Semicolon",
    Quote = "Quote",
    Enter = "Enter",
    ShiftLeft = "ShiftLeft",
    Comma = "Comma",
    Period = "Period",
    Slash = "Slash",
    ShiftRight = "ShiftRight",
    ControlLeft = "ControlLeft",
    AltLeft = "AltLeft",
    AltRight = "AltRight",
    ControlRight = "ControlRight",
    MetaLeft = "MetaLeft",
    MetaRight = "MetaRight",
    ContextMenu = "ContextMenu",
    ArrowLeft = "ArrowLeft",
    ArrowUp = "ArrowUp",
    ArrowRight = "ArrowRight",
    ArrowDown = "ArrowDown",
}

export class InputManager extends Listener {
    mousePosition: Vector2 = Vector2.zero;

    keyStates: {
        [key: string]: {
            down: boolean;
            thisFrame: boolean;
        };
    } = {};

    mouseStates: {
        [key: number]: {
            down: boolean;
            thisFrame: boolean;
        };
    } = {
            0: {
                down: false,
                thisFrame: false,
            },
            1: {
                down: false,
                thisFrame: false,
            },
            2: {
                down: false,
                thisFrame: false,
            },
        };

    constructor() {
        super();

        for (const key in KeyCode) {
            this.keyStates[key] = {
                down: false,
                thisFrame: false
            };
        }

        this.on("keydown", (code: string) => {

            if (this.keyStates[code].down) return;

            this.keyStates[code].down = true;
            this.keyStates[code].thisFrame = true;
        });

        this.on("keyup", (code: string) => {

            this.keyStates[code].down = false;
            this.keyStates[code].thisFrame = true;
        });

        this.on("mousedown", (value: number) => {
            if (this.mouseStates[value].down) return;

            this.mouseStates[value].down = true;
            this.mouseStates[value].thisFrame = true;
        });

        this.on("mouseup", (value: number) => {
            if (!this.mouseStates[value].down) return;

            this.mouseStates[value].down = false;
            this.mouseStates[value].thisFrame = true;
        });

        this.on("mousemove", (pos: Vector2) => {
            this.mousePosition = pos;
        });
    }

    GetKey(code: KeyCode) {
        return this.keyStates[code].down;
    }

    GetKeyDown(code: KeyCode) {
        return this.keyStates[code].down && this.keyStates[code].thisFrame;
    }

    GetKeyUp(code: KeyCode) {
        return !this.keyStates[code].down && this.keyStates[code].thisFrame;
    }

    GetMouseButton(code: number) {
        return this.mouseStates[code].down;
    }

    GetMouseButtonDown(code: number) {
        return this.mouseStates[code].down && this.mouseStates[code].thisFrame;
    }

    GetMouseButtonUp(code: number) {
        return !this.mouseStates[code].down && this.mouseStates[code].thisFrame;
    }

    ClearThisFrame() {
        for (const key in this.keyStates) {
            this.keyStates[key].thisFrame = false;
        }

        for (const key in this.mouseStates) {
            this.mouseStates[key].thisFrame = false;
        }
    }
}

export const Input = new InputManager();
